import React, { useState } from "react";
import { FaGift } from "react-icons/fa";
import { FaUser } from "react-icons/fa";


export default function FilterBox({
  filterDropdownRef,
  traders = [],
  selectedFilters = [],
  updateSelectedFiltersFromCheckbox,
  clearAllFilters,
  applyFilters,
  closeFilterDropdown,
}) {
  const [filterSearch, setFilterSearch] = useState("");

  const filteredTraders = traders.filter((trader) =>
    trader.name
      ?.toLowerCase()
      .includes(filterSearch.trim().toLowerCase()),
  );

  const isFilterSelected = (name, type) =>
    selectedFilters.some(
      (filter) => filter.name === name && filter.type === type,
    );

  return (
    <div id="filterDropdown" className="fixed inset-0 z-40">
      <div
        className="absolute inset-0 bg-purple-500/20 backdrop-blur-sm"
        onClick={closeFilterDropdown}
      />

      <div className="absolute top-36 left-5 right-5">
        <div
          ref={filterDropdownRef}
          className="bg-white/95 backdrop-blur-lg rounded-xl shadow-2xl border border-white/30 max-h-80 overflow-hidden animate-slide-down"
        >
          <div className="p-4 border-b border-gray-100">
            <h3 className="text-lg font-bold text-gray-900 mb-3">
              Filter Options
            </h3>

            <input
              type="text"
              placeholder="Search traders..."
              value={filterSearch}
              onChange={(e) => setFilterSearch(e.target.value)}
              className="w-full text-sm border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>

          <div className="max-h-60 overflow-y-auto">
            <div className="p-3 border-b border-gray-50">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">
                General
              </h4>

              <div className="space-y-2">
                <label className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200">
                  <input
                    type="checkbox"
                    className="mr-3 rounded"
                    style={{ accentColor: "#7c90e9" }}
                    checked={isFilterSelected("free", "general")}
                    onChange={(e) =>
                      updateSelectedFiltersFromCheckbox(
                        "free",
                        "general",
                        e.target.checked,
                      )
                    }
                  />

                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3">
                      <FaGift className="text-white text-sm" />
                    </div>
                    <span className="text-sm font-medium">Free</span>
                  </div>
                </label>

                <label className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200">
                  <input
                    type="checkbox"
                    className="mr-3 rounded"
                    style={{ accentColor: "#7c90e9" }}
                    checked={isFilterSelected("my-signals", "general")}
                    onChange={(e) =>
                      updateSelectedFiltersFromCheckbox(
                        "my-signals",
                        "general",
                        e.target.checked,
                      )
                    }
                  />

                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                      <FaUser className="text-white text-sm" />
                    </div>
                    <span className="text-sm font-medium">My Signals</span>
                  </div>
                </label>
              </div>
            </div>

            <div className="p-3">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">
                Traders
              </h4>

              <div className="space-y-1 pb-10">
                {filteredTraders.map((trader, idx) => (
                  <label
                    key={trader.id ?? trader.name}
                    className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200"
                  >
                    <input
                      type="checkbox"
                      className="mr-3 rounded"
                      style={{ accentColor: "#7c90e9" }}
                      checked={isFilterSelected(trader.name, "trader")}
                      onChange={(e) =>
                        updateSelectedFiltersFromCheckbox(
                          trader.name,
                          "trader",
                          e.target.checked,
                        )
                      }
                    />

                    <img
                      src={`https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-${2 + idx}.jpg`}
                      alt={trader.name}
                      className="w-8 h-8 rounded-full mr-3"
                    />

                    <div className="flex-1">
                      <p className="text-sm font-semibold">
                        {trader.name}
                      </p>
                      <p className="text-xs text-gray-500">PRO Trader</p>
                    </div>

                    <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full">
                      PRO
                    </span>
                  </label>
                ))}

                {filteredTraders.length === 0 && (
                  <p className="text-sm text-gray-500 py-3 text-center">
                    No traders found
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="p-3 border-t border-gray-100 flex justify-between items-center bg-white/80">
            <button
              type="button"
              onClick={clearAllFilters}
              className="text-sm font-semibold transition-colors duration-200"
              style={{ color: "#7c90e9" }}
            >
              Clear All
            </button>

            <button
              type="button"
              onClick={applyFilters}
              className="flex items-center text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200"
              style={{ backgroundColor: "#7c90e9" }}
            >
              <i className="fas fa-check mr-2" />
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// import React, { useState } from "react";
//
// export default function FilterBox({ onClose }) {
//     const [selectedFilters, setSelectedFilters] = useState([]);
//
//     function toggleFilter(name) {
//         setSelectedFilters((prev) =>
//             prev.includes(name)
//                 ? prev.filter((f) => f !== name)
//                 : [...prev, name]
//         );
//     }
//
//     function clearAll() {
//         setSelectedFilters([]);
//     }
//
//     function applyFilters() {
//         console.log("Filters applied:", selectedFilters);
//         onClose();
//     }
//
//     return (
//         <div id="filterDropdown" className="fixed inset-0 z-40">
//             <div
//                 className="absolute inset-0 bg-purple-500/20 backdrop-blur-sm"
//                 onClick={onClose}
//             ></div>
//             <div className="absolute top-36 left-5 right-5">
//                 <div className="bg-white/95 backdrop-blur-lg rounded-xl shadow-2xl border border-white/30 max-h-80 overflow-hidden animate-slide-down">
//                     {/* هدر فیلتر */}
//                     <div className="p-4 border-b border-gray-100">
//                         <h3 className="text-lg font-bold text-gray-900 mb-3">
//                             Filter Options
//                         </h3>
//                         <input
//                             type="text"
//                             placeholder="Search traders or filters..."
//                             className="w-full text-sm border border-gray-300 rounded-lg px-3 py-2"
//                         />
//                     </div>
//
//                     {/* گزینه‌های فیلتر */}
//                     <div className="max-h-60 overflow-y-auto">
//                         <div className="p-3 border-b border-gray-50">
//                             <h4 className="text-sm font-semibold text-gray-700 mb-2">
//                                 General
//                             </h4>
//                             <div className="space-y-2">
//                                 <label className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200">
//                                     <input
//                                         type="checkbox"
//                                         checked={selectedFilters.includes("Free")}
//                                         onChange={() => toggleFilter("Free")}
//                                         className="mr-3 rounded"
//                                         style={{ accentColor: "#7c90e9" }}
//                                     />
//                                     <div className="flex items-center">
//                                         <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3">
//                                             <i className="fas fa-gift text-white text-sm"></i>
//                                         </div>
//                                         <span className="text-sm font-medium">Free</span>
//                                     </div>
//                                 </label>
//
//                                 <label className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200">
//                                     <input
//                                         type="checkbox"
//                                         checked={selectedFilters.includes("My Signals")}
//                                         onChange={() => toggleFilter("My Signals")}
//                                         className="mr-3 rounded"
//                                         style={{ accentColor: "#7c90e9" }}
//                                     />
//                                     <div className="flex items-center">
//                                         <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
//                                             <i className="fas fa-user text-white text-sm"></i>
//                                         </div>
//                                         <span className="text-sm font-medium">My Signals</span>
//                                     </div>
//                                 </label>
//                             </div>
//                         </div>
//
//                         {/* لیست تریدرها */}
//                         <div className="p-3">
//                             <h4 className="text-sm font-semibold text-gray-700 mb-2">
//                                 Traders
//                             </h4>
//                             <div className="space-y-1">
//                                 {[
//                                     "Ahmad Rezaei",
//                                     "Sara Ahmadi",
//                                     "Ali Hosseini",
//                                     "Mohammad Karimi",
//                                     "Hassan Moradi",
//                                     "Maryam Gholami",
//                                 ].map((name, idx) => (
//                                     <label
//                                         key={name}
//                                         className="flex items-center p-2 hover:bg-white/70 cursor-pointer rounded-lg transition-colors duration-200"
//                                     >
//                                         <input
//                                             type="checkbox"
//                                             checked={selectedFilters.includes(name)}
//                                             onChange={() => toggleFilter(name)}
//                                             className="mr-3 rounded"
//                                             style={{ accentColor: "#7c90e9" }}
//                                         />
//                                         <img
//                                             src={`https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-${
//                                                 2 + idx
//                                             }.jpg`}
//                                             className="w-8 h-8 rounded-full mr-3"
//                                             alt={name}
//                                         />
//                                         <div className="flex-1">
//                                             <p className="text-sm font-semibold">{name}</p>
//                                             <p className="text-xs text-gray-500">PRO Trader</p>
//                                         </div>
//                                         <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full">
//                       PRO
//                     </span>
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//
//                     {/* دکمه‌ها */}
//                     <div className="p-3 border-t border-gray-100 flex justify-between items-center bg-white/80">
//                         <button
//                             onClick={clearAll}
//                             className="text-sm font-semibold transition-colors duration-200"
//                             style={{ color: "#7c90e9" }}
//                         >
//                             Clear All
//                         </button>
//                         <div className="flex items-center space-x-3">
//                             <button
//                                 onClick={applyFilters}
//                                 className="flex items-center text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200"
//                                 style={{ backgroundColor: "#7c90e9" }}
//                             >
//                                 <i className="fas fa-check mr-2"></i>OK
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
